import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWR from "swr";
const getCustomerLeads = async (params) => jwtAxios.get(URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEADS, { params });

const useGetCustomerLeads = (params) => {
  const fetcher = () => getCustomerLeads(params);
  return useSWR({ url: URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEADS, params, tags: ["#customerLeads"] }, fetcher);
};

export default useGetCustomerLeads;
